import { render, staticRenderFns } from "./LocationConfirmModal.vue?vue&type=template&id=64a1bd33&scoped=true&"
import script from "./LocationConfirmModal.vue?vue&type=script&lang=js&"
export * from "./LocationConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./LocationConfirmModal.vue?vue&type=style&index=0&id=64a1bd33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1bd33",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadarMapSingle: require('/opt/build/repo/components/locations/RadarMapSingle.vue').default,IconPinColor: require('/opt/build/repo/components/icons/IconPinColor.vue').default})
